import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "一括請求" },
  { value: 2, text: "分割請求" },
]);
